import React from 'react';
import cx from 'classnames';
import PropTypes from 'prop-types';

import { MobileTooltip } from './';
import { fullName, canUserViewAppointmentContactInfo } from '../../../../../common/helpers/users';
import withPermissions from '../../../../../auth/utils/withPermissions';
import { maskEmail, maskPhoneNumber } from '../../../../../common/helpers/mask';

/* eslint-disable jsx-a11y/no-static-element-interactions */
const SurvivingCustomer = ({ customer, onClick, isSelected, isMobileCustomer, permissions }) => (
  <div
    className={cx('c-table-card__row', { 'c-table-card__row--bordered': isSelected })}
    onClick={onClick}
  >
    <div className="c-table-card__cell u-1/3 u-break-word">
      <MobileTooltip display-if={isMobileCustomer}>
        <div className="u-inline-block u-align-middle u-ml--">
          {fullName(customer)}
        </div>
      </MobileTooltip>
      <div display-if={!isMobileCustomer}>
        {fullName(customer)}
      </div>
    </div>
    <div className="c-table-card__cell u-1/3 u-break-word">
      <div className="u-type--underline">
        {!canUserViewAppointmentContactInfo(permissions) ? maskEmail(customer.email) : customer.email}
      </div>
    </div>
    <div className="c-table-card__cell u-1/3 u-break-word">
      <div>
        {!canUserViewAppointmentContactInfo(permissions) ? maskPhoneNumber(customer.phone) : customer.phone}
      </div>
    </div>
  </div>
);

SurvivingCustomer.propTypes = {
  onClick: PropTypes.func.isRequired,
  isSelected: PropTypes.bool.isRequired,
  customer: PropTypes.object.isRequired,
  isMobileCustomer: PropTypes.bool.isRequired,
  permissions: PropTypes.object.isRequired,
};

export default withPermissions(SurvivingCustomer);
